import { Button } from "@mui/base";
import React, { useState } from "react";
import ColorPicker from "react-pick-color";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, TextField } from "@mui/material";

function AddNewTag({ open, handleClose, setopenAddNewTagModal, onAddTag, existingTagNames = [] }) {
    const [color, setColor] = useState("#000001");
    const [tagName, setTagName] = useState("");
    const [showError, setShowError] = useState(false);
    const handleDialogClose = () => {
        handleClose();
        setTagName("");
        setColor("#000001");
        setShowError(false);
    };

    const trimmedName = (tagName || "").trim();
    const isEmpty = trimmedName.length === 0;
    // const isDuplicate = existingTagNames.some((n) => (n || "").trim().toLowerCase() === trimmedName.toLowerCase());

    const isValid = !isEmpty

    const handleAddTag = () => {
        setShowError(true);
        if (!isValid) return;
        const newTag = {
            id: Date.now(),
            name: trimmedName,
            color: color,
            times_used: 0,
        };
        onAddTag(newTag);
        handleDialogClose();
    };

    return (
        <Dialog className="dialog-container-comment-library" open={open} onClose={handleDialogClose} aria-labelledby="category-modal" aria-describedby="category-modal-description" disableScrollLock keepMounted>
            <DialogTitle className="comment-library-dialog-title" sx={{ p: "16px !important", mb: 2, fontSize: "24px", fontWeight: 600, color: "#252525", fontFamily: "Open Sans" }}>
                New Tag
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container sx={{ padding: "24px 32px !important" }} direction={{ xs: "column", md: "row", lg: "row" }}>
                    <Grid item xs={12} md={6} lg={7}>
                        <FormControl variant="standard" fullWidth>
                            <label className="input-form-label" id="categoryName" style={{ fontSize: "15px", fontWeight: 600 }}>
                                Tag Name
                            </label>
                            <TextField
                                size="small"
                                variant="outlined"
                                type="text"
                                onChange={(e) => setTagName(e.target.value)}
                                value={tagName}
                                name="Name"
                                sx={{
                                    width: "100% !important",
                                    height: "67px",
                                    fontSize: "15px",
                                }}
                                error={(showError && isEmpty)}
                                helperText={
                                    showError && isEmpty
                                        ? "* Tag name is required"
                                        : " "
                                }
                                FormHelperTextProps={{
                                    sx: { margin: 0, padding: "4px 0px", lineHeight: "16px" }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={5} lg={5}>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "end",
                                width: "100%",
                                height: "100%",
                            }}
                            className="custom-color-picker"
                        >
                            <ColorPicker hideAlpha color={color} onChange={(color) => setColor(color.hex)} style={{ width: "100%", height: "100%" }} theme={{ width: "352px", borderColor: "none !important", boxShadow: "none !important" }} />
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <Divider />
            <DialogActions className="comment-library-summary-action">
                <div className="comment-library-action-btn">
                    <Button className="cl-cancel-tag-btn" onClick={handleDialogClose}>
                        Close
                    </Button>
                    <Button
                        className={"cl-add-tag-btn"}
                        style={{ width: "130px !important" }}
                        onClick={handleAddTag}
                    >
                        Save
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

export default AddNewTag;
